import { PluginInitializerService } from 'core-client/api'
import { WmsChartService } from './wms-chart.service'

export function wmsChartInitializerFactory(
  wmsChartService: WmsChartService,
  configurationService: PluginInitializerService
) {
  return () =>
    new Promise<void>((resolve) => {
      const init = async () => {
        await wmsChartService.setup()
      }

      configurationService.setup('wmsChartLoader', init, resolve)
    })
}
